import { blue, green, lime, cyan, red, orange } from '@ant-design/colors';

export const BORDER_COLOR = '#e3e3e3';
export const BACKGROUND_COLOR = 'whitesmoke';
export const PRIMARY_COLOR = '#39af78';
export const PRIME_TEXT_COLOR = '#3e3d3d';
export const DESCRIPTION_COLOR = '#a1a1a1';
export const INPUT_INLINE_ICON_COLOR = 'rgba(0, 0, 0, 0.35)';
